export const CoverImageConstants = {
    heightMobile: '160px',
    heightDesktop: '200px',
};